import React from 'react'
import img from '../../Images/Group (4).png'
import img2 from '../../Images/Group 1171279366 (2).png'
const WhyChooseUs = () => {
    return (
        <section className='why_choose_us_section'>
            <h1>Why Choose Us</h1>
            <div className='why_choose_us_card_wrapper'>

            {[1,2,3,4,5,6].map((e,i)=>{
                   return(
                    <>
                    <div className='why_card'>
                    <div className='card_img'>
                        <img src={img} />
                    </div>
                    <p className='perfect_para'>Perfect Property</p>
                    <p className='perfect_para2'>
                        Lorem ipsum is a dummy or placeholder text commonly used in graphic design, publishing, and web development to fill empty spaces
                    </p>
                </div>
                    </>
                   )
            })}

            
            </div>
            <img className='img_bg' src={img2}/>
        </section>
    )
}

export default WhyChooseUs
